import DOMPurify from "dompurify";

export const sanitiseHtml = (html) => DOMPurify.sanitize(html, { ADD_ATTR: ["target"] });
